import { getDateFromString } from 'shared-components';
import { EducationDoc, IDate } from '../../../../../types';
import { isOverXMonthsAgo } from '../../../../../utilities/validation';

type EducationDocMeta = Pick<
  EducationDoc,
  | 'hasOfficialLetterhead'
  | 'nameAndLogoVisible'
  | 'officiallySigned'
  | 'hasDate'
  | 'selectedTextBodyReq'
  | 'fundConditions'
  | 'hasContactDetails'
  | 'dateOnLetter'
>;

const getHighlightedErrorSections = (doc: EducationDocMeta) => {
  const { hasDate, selectedTextBodyReq = [], fundConditions, hasContactDetails } = doc;

  // Are there any errors?
  // highlight the specific sections
  const hasDateHighlight = hasDate === false ? ['2.1', '2.2'] : [];
  const dateOnLetter: IDate = getDateFromString(doc.dateOnLetter || '');
  const isOver6MonthsOld =
    hasDate === true ? isOverXMonthsAgo(`${dateOnLetter.YYYY}-${dateOnLetter.MM}-${dateOnLetter.DD}`, 5.5) : false;
  const dateOnLetterHighlight = hasDate === true && isOver6MonthsOld ? ['2.1'] : [];
  const selectedTextBodyReqHighlight = [];
  if (!selectedTextBodyReq.includes('fullName')) {
    selectedTextBodyReqHighlight.push('3.1');
  }
  if (!selectedTextBodyReq.includes('orgName')) {
    selectedTextBodyReqHighlight.push('3.2');
  }
  if (!selectedTextBodyReq.includes('courseName')) {
    selectedTextBodyReqHighlight.push('3.3');
  }
  if (!selectedTextBodyReq.includes('contributionAmount')) {
    selectedTextBodyReqHighlight.push('3.4');
  }
  if (!selectedTextBodyReq.includes('periodCovered')) {
    selectedTextBodyReqHighlight.push('3.5');
  }
  if (!selectedTextBodyReq.includes('loanName')) {
    selectedTextBodyReqHighlight.push('3.6');
  }
  if (!selectedTextBodyReq.includes('fundsReleased')) {
    selectedTextBodyReqHighlight.push('3.7');
  }

  const fundConditionsHighlight = fundConditions === true ? ['3.8'] : [];
  const hasContactDetailsHighlight = hasContactDetails === false ? ['4.1'] : [];
  if (
    hasDateHighlight.length ||
    dateOnLetterHighlight.length ||
    selectedTextBodyReqHighlight.length ||
    fundConditionsHighlight.length ||
    hasContactDetailsHighlight.length
  ) {
    // unique values only AND
    // remove empty strings in array
    return [
      ...new Set(
        [
          ...hasDateHighlight,
          ...dateOnLetterHighlight,
          ...selectedTextBodyReqHighlight,
          ...fundConditionsHighlight,
          ...hasContactDetailsHighlight
        ].filter(Boolean)
      )
    ];
  }
  return [];
};

export default getHighlightedErrorSections;
